<div class="container layout-column category-shell">
  <!-- <gh-breadcrumb></gh-breadcrumb> -->
  <div class="main-content">
    <div class="article-details">

      @if (articleDetails) {
        <div class="layout-column article-wrapper">
          <div class="layout-row article-info spacer-top-32">
            <span class="layout-row align-middle">
              <div class="category-icon small-icon">
                <img [src]="articleDetails.category.marker" [alt]="articleDetails.category.slug" width="16px" height="16px">
              </div>
              <a [href]="'./'+articleDetails.category.slug" class="spacer-left-8 small">{{articleDetails.category.name}}</a>
            </span>
          </div>
          <h1 class="article-title" [innerHTML]="articleDetails.title"></h1>
          @if (articleDetails.hashes.length) {
            <div class="article-info tags layout-row flex-wrap spacer-vr-8">
              @for (item of articleDetails.hashes; track item) {
<a (click)="hashClick(item.hash, 'article')" [routerLink]="['/search-results', 'terms', item.tag]"
            class="small txt-navy-light spacer-right-8">{{item.hash}}</a>
}
        </div>
}

        <div class="hero-image">
          <img [src]="articleDetails.heroImageUrl" [alt]="articleDetails.title" width="100%" height="100%">
        </div>

        <div class="layout-column spacer-bottom-24 article-info info">
          <div class="layout-row align-middle space-between">
            <div class="layout-row align-middle text-right">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#615F73" d="M8.16895 4H9.16895V7.79289L11.5225 10.1464L10.8154 10.8536L8.16895 8.20711V4Z" />
                <path fill="#615F73"
                  d="M8.66895 2C5.35524 2 2.66895 4.68629 2.66895 8C2.66895 11.3137 5.35524 14 8.66895 14C11.9827 14 14.6689 11.3137 14.6689 8C14.6689 4.68629 11.9827 2 8.66895 2ZM1.66895 8C1.66895 4.13401 4.80295 1 8.66895 1C12.5349 1 15.6689 4.13401 15.6689 8C15.6689 11.866 12.5349 15 8.66895 15C4.80295 15 1.66895 11.866 1.66895 8Z" />
              </svg>
              <span class="spacer-left-8 txt-navy-light">{{articleDetails.readTime}}</span>
            </div>
            <div class="layout-row social-links">
              <a id="follow-facebook" [href]="'http://www.facebook.com/sharer/sharer.php?u=' + permaLink" target="_blank" rel="noopener"
                aria-label="share on facebook" (click)="navClick('facebook', 'article')">
                  <svg width="9" height="19" viewBox="0 0 9 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#615F73"
                      d="M5.9653 18.0129H2.02262V9.31762H0.0524902V6.32151H2.02262V4.52275C2.02262 2.07867 3.13448 0.624512 6.29536 0.624512H8.92623V3.62172H7.28194C6.05143 3.62172 5.97012 4.04041 5.97012 4.82181L5.9647 6.32151H8.94429L8.59556 9.31762H5.9647V18.0129H5.9653Z" />
                  </svg>
                </a>
              <a id="follow-twitter" [href]="'https://twitter.com/share?url=' + permaLink + '&text=' + articleDetails?.title" target="_blank" rel="noopener"
                aria-label="share on twitter" (click)="navClick('twitter', 'article')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 25 25" fill="none">
                    <path
                      d="M14.6076 10.9296L23.3456 0.772461H21.275L13.6878 9.59177L7.62797 0.772461H0.638672L9.80233 14.1088L0.638672 24.7601H2.7094L10.7216 15.4467L17.1213 24.7601H24.1106L14.6076 10.9296ZM3.45551 2.33128H6.63603L21.2759 23.2722H18.0954L3.45551 2.33128Z"
                      fill="#615F73" />
                  </svg>
                </a>
                <a id="follow-instagram" href="https://www.instagram.com/gohenry/?hl=en" target="_blank" rel="noopener" aria-label="follow on instagram">
                  <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#615F73" d="M9.4,0.9C7,0.9,6.7,1,5.7,1c-1,0-1.6,0.2-2.2,0.4c-0.6,0.2-1.1,0.5-1.6,1c-0.5,0.5-0.8,1-1,1.6
          C0.7,4.6,0.5,5.2,0.5,6.2c0,1-0.1,1.3-0.1,3.7c0,2.4,0,2.7,0.1,3.7c0,1,0.2,1.6,0.4,2.2c0.2,0.6,0.5,1.1,1,1.6c0.5,0.5,1,0.8,1.6,1
          c0.6,0.2,1.2,0.4,2.2,0.4c1,0,1.3,0.1,3.7,0.1c2.4,0,2.7,0,3.7-0.1c1,0,1.6-0.2,2.2-0.4c0.6-0.2,1.1-0.5,1.6-1c0.5-0.5,0.8-1,1-1.6
          c0.2-0.6,0.4-1.2,0.4-2.2c0-1,0.1-1.3,0.1-3.7c0-2.4,0-2.7-0.1-3.7c0-1-0.2-1.6-0.4-2.2c-0.2-0.6-0.5-1.1-1-1.6
          c-0.5-0.5-1-0.8-1.6-1C14.7,1.2,14,1,13.1,1C12.1,1,11.8,0.9,9.4,0.9z M9.4,2.6c2.4,0,2.7,0,3.6,0.1c0.9,0,1.3,0.2,1.7,0.3
          c0.4,0.2,0.7,0.4,1,0.7c0.3,0.3,0.5,0.6,0.7,1c0.1,0.3,0.3,0.8,0.3,1.7c0,0.9,0.1,1.2,0.1,3.6c0,2.4,0,2.7-0.1,3.6
          c0,0.9-0.2,1.3-0.3,1.7c-0.2,0.4-0.4,0.7-0.7,1c-0.3,0.3-0.6,0.5-1,0.7c-0.3,0.1-0.8,0.3-1.7,0.3c-0.9,0-1.2,0.1-3.6,0.1
          c-2.4,0-2.7,0-3.6-0.1c-0.9,0-1.3-0.2-1.7-0.3c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.5-0.6-0.7-1c-0.1-0.3-0.3-0.8-0.3-1.7
          c0-0.9-0.1-1.2-0.1-3.6c0-2.4,0-2.7,0.1-3.6c0-0.9,0.2-1.3,0.3-1.7c0.2-0.4,0.4-0.7,0.7-1c0.3-0.3,0.6-0.5,1-0.7
          c0.3-0.1,0.8-0.3,1.7-0.3C6.7,2.6,7,2.6,9.4,2.6z M9.4,12.9c-1.6,0-3-1.3-3-3c0-1.6,1.3-3,3-3c1.6,0,3,1.3,3,3
          C12.4,11.5,11,12.9,9.4,12.9z M9.4,5.3c-2.5,0-4.6,2.1-4.6,4.6c0,2.5,2.1,4.6,4.6,4.6S14,12.4,14,9.9C14,7.3,11.9,5.3,9.4,5.3z
           M15.2,5.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1S13.6,4,14.2,4S15.2,4.5,15.2,5.1z" />
                  </svg>
                </a>
              </div>
            </div>
            <span class="txt-navy-light">
              Published {{articleDetails.publishDate}}
            </span>
          </div>
          <div class="article layout-column" [innerHTML]="articleHtml | ghSafeHtml"></div>
          <div class="h-separator"></div>
          <div class="layout-row">
            <div class="author-avatar">
              <img [src]="articleDetails.author.authorImageUrl" [alt]="articleDetails.author.authorImageUrl" width="50px" height="50px">
            </div>
            <div class="layout-column">
              <span class="spacer-bottom-8 txt-navy-light">Written by <a [href]="'./author/'+articleDetails.author.slug"
              [title]="articleDetails.author.fullName">{{articleDetails.author.fullName}}</a></span>
              <span class="layout-row align-middle info txt-navy-light">
                Published {{articleDetails.publishDate}} ● {{articleDetails.readTime}}
              </span>
            </div>
          </div>
          <div class="layout-row article-info spacer-top-16 spacer-bottom-32">
            <span class="layout-row align-middle">
              <div class="category-icon small-icon">
                <img [src]="articleDetails.category.marker" [alt]="articleDetails.category.slug" width="16px" height="16px">
              </div>
              <a [href]="'./'+articleDetails.category.slug" class="spacer-left-8 small">{{articleDetails.category.name}}</a>
            </span>
          </div>
        </div>
      }

    </div>
  </div>
</div>

@if (articleDetails) {
  <div class="layout-row align-center pad-vr-48 bgr-mango">
    <div class="pad-40 bgr-white">
      <h2>Enjoyed it? Share it!</h2>
      <div class="layout-row social-links align-center">
      <a id="share-follow-facebook" [href]="'http://www.facebook.com/sharer/sharer.php?u=' + permaLink" target="_blank" rel="noopener"
        aria-label="share on facebook" (click)="navClick('facebook', 'post share section')">
          <svg width="9" height="19" viewBox="0 0 9 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#615F73"
              d="M5.9653 18.0129H2.02262V9.31762H0.0524902V6.32151H2.02262V4.52275C2.02262 2.07867 3.13448 0.624512 6.29536 0.624512H8.92623V3.62172H7.28194C6.05143 3.62172 5.97012 4.04041 5.97012 4.82181L5.9647 6.32151H8.94429L8.59556 9.31762H5.9647V18.0129H5.9653Z" />
          </svg>
        </a>
      <a id="share-follow-twitter" [href]="'https://twitter.com/share?url=' + permaLink + '&text=' + articleDetails?.title" target="_blank" rel="noopener"
        aria-label="share on twitter" (click)="navClick('twitter', 'post share section')">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 25 25" fill="none">
            <path
              d="M14.6076 10.9296L23.3456 0.772461H21.275L13.6878 9.59177L7.62797 0.772461H0.638672L9.80233 14.1088L0.638672 24.7601H2.7094L10.7216 15.4467L17.1213 24.7601H24.1106L14.6076 10.9296ZM3.45551 2.33128H6.63603L21.2759 23.2722H18.0954L3.45551 2.33128Z"
              fill="#615F73" />
          </svg>
        </a>
        <a id="share-follow-instagram" href="https://www.instagram.com/gohenry/?hl=en" target="_blank" rel="noopener" aria-label="follow on instagram">
          <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
          <path fill="#615F73" d="M9.4,0.9C7,0.9,6.7,1,5.7,1c-1,0-1.6,0.2-2.2,0.4c-0.6,0.2-1.1,0.5-1.6,1c-0.5,0.5-0.8,1-1,1.6
C0.7,4.6,0.5,5.2,0.5,6.2c0,1-0.1,1.3-0.1,3.7c0,2.4,0,2.7,0.1,3.7c0,1,0.2,1.6,0.4,2.2c0.2,0.6,0.5,1.1,1,1.6c0.5,0.5,1,0.8,1.6,1
c0.6,0.2,1.2,0.4,2.2,0.4c1,0,1.3,0.1,3.7,0.1c2.4,0,2.7,0,3.7-0.1c1,0,1.6-0.2,2.2-0.4c0.6-0.2,1.1-0.5,1.6-1c0.5-0.5,0.8-1,1-1.6
c0.2-0.6,0.4-1.2,0.4-2.2c0-1,0.1-1.3,0.1-3.7c0-2.4,0-2.7-0.1-3.7c0-1-0.2-1.6-0.4-2.2c-0.2-0.6-0.5-1.1-1-1.6
c-0.5-0.5-1-0.8-1.6-1C14.7,1.2,14,1,13.1,1C12.1,1,11.8,0.9,9.4,0.9z M9.4,2.6c2.4,0,2.7,0,3.6,0.1c0.9,0,1.3,0.2,1.7,0.3
c0.4,0.2,0.7,0.4,1,0.7c0.3,0.3,0.5,0.6,0.7,1c0.1,0.3,0.3,0.8,0.3,1.7c0,0.9,0.1,1.2,0.1,3.6c0,2.4,0,2.7-0.1,3.6
c0,0.9-0.2,1.3-0.3,1.7c-0.2,0.4-0.4,0.7-0.7,1c-0.3,0.3-0.6,0.5-1,0.7c-0.3,0.1-0.8,0.3-1.7,0.3c-0.9,0-1.2,0.1-3.6,0.1
c-2.4,0-2.7,0-3.6-0.1c-0.9,0-1.3-0.2-1.7-0.3c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.5-0.6-0.7-1c-0.1-0.3-0.3-0.8-0.3-1.7
c0-0.9-0.1-1.2-0.1-3.6c0-2.4,0-2.7,0.1-3.6c0-0.9,0.2-1.3,0.3-1.7c0.2-0.4,0.4-0.7,0.7-1c0.3-0.3,0.6-0.5,1-0.7
c0.3-0.1,0.8-0.3,1.7-0.3C6.7,2.6,7,2.6,9.4,2.6z M9.4,12.9c-1.6,0-3-1.3-3-3c0-1.6,1.3-3,3-3c1.6,0,3,1.3,3,3
C12.4,11.5,11,12.9,9.4,12.9z M9.4,5.3c-2.5,0-4.6,2.1-4.6,4.6c0,2.5,2.1,4.6,4.6,4.6S14,12.4,14,9.9C14,7.3,11.9,5.3,9.4,5.3z
 M15.2,5.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1S13.6,4,14.2,4S15.2,4.5,15.2,5.1z" />
          </svg>
        </a>
      </div>
    </div>
  </div>
}

<div class="bgr-light-grey category-section">
  <gh-category-menu-section></gh-category-menu-section>
</div>
